module.exports = __webpack_public_path__ + "static/electrode-placement-f6594a13d80dc05553884cda968f7a46.png";